import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/data/content";

const ease = [0.16, 1, 0.3, 1];

export default function Process() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="bg-[#1E3A5F] text-white py-24 md:py-32 relative overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
                    <div className="md:col-span-6">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-[#DC2626]" />
                            <span className="overline text-white/70">04 · Process</span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
                            De l'idée<br />
                            <span className="italic">à la pose finale.</span>
                        </h2>
                    </div>
                    <div className="md:col-span-5 md:col-start-8 flex items-end">
                        <p className="text-white/70 text-lg leading-relaxed">
                            Cinq étapes maîtrisées, une méthodologie limpide.
                            Chaque projet suit un cheminement clair pour garantir
                            un résultat à la hauteur de vos exigences.
                        </p>
                    </div>
                </div>

                <div className="relative">
                    {/* Vertical line */}
                    <div className="hidden md:block absolute left-[7%] top-0 bottom-0 w-px bg-white/15" />

                    <div className="space-y-16 md:space-y-20">
                        {PROCESS_STEPS.map((s, i) => (
                            <motion.div
                                key={s.n}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.9, delay: i * 0.08, ease }}
                                data-testid={`process-step-${i}`}
                                className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start relative"
                            >
                                <div className="md:col-span-2 flex items-center gap-4">
                                    <div className="hidden md:block w-3 h-3 rounded-full bg-[#DC2626] relative z-10 ring-4 ring-[#1E3A5F]" />
                                    <span className="font-serif text-3xl md:text-2xl text-white/40">
                                        {s.n}
                                    </span>
                                </div>
                                <div className="md:col-span-5">
                                    <h3 className="font-serif text-3xl md:text-4xl">{s.title}</h3>
                                </div>
                                <div className="md:col-span-5">
                                    <p className="text-white/70 text-lg leading-relaxed max-w-md">
                                        {s.text}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
